import VConsole from 'vconsole'
import { isMobile } from '@/utils/misc'
import { isLan, isTesting, isProduction } from '@/config/constants'

/**
 * 是否强制打开控制台（仅移动端）
 * 默认为 false，仅当移动端且为测试环境和内网环境时打开（因为需要排查问题）
 * 当强制打开为 true 时，除生产环境外的其他环境移动端均打开控制台
 */
let forceShow: boolean = false

export const initVConsole = () => {
  // 生产环境禁止打开
  if (isProduction) return

  // 非移动端没必要打开
  if (!isMobile()) return

  if (!forceShow) {
    if (isLan || isTesting) {
      new VConsole()
    }
  } else {
    new VConsole()
  }
}